angular
  .module('common.directives')
  .directive('edgeAgressiveReport', function () {
    return {
      scope: {
        edge: '=',
        eventSearch: '='
      },
      templateUrl:
        './templates/edgeAggressiveReports.view.html?t=' + webpackHash,
      link: function ($scope, $element, attrs) {},
      controller: 'edgeAgressiveReportsController'
    }
  })
